/**
 * ManageNav - Sub-navigation for Manage section
 *
 * Shows tabs for accessible sub-sections based on user role.
 * Uses hash-based routing for sub-sections.
 *
 * Visual: shared TabBar pill-button pattern (matches Statistics).
 */

import { TabBar } from '../../../../shared/components/redesign';

const NAV_ITEMS = [
  { key: 'dashboard', hash: '', label: 'Overview', access: 'all' },
  { key: 'training', hash: 'training', label: 'Training', access: 'all' },
  { key: 'teams', hash: 'teams', label: 'Teams', access: 'teams' },
  { key: 'persons', hash: 'persons', label: 'Persons', access: 'persons' },
  { key: 'unlinked', hash: 'unlinked', label: 'Unlinked', access: 'persons' },
  { key: 'competitions', hash: 'competitions', label: 'Competitions', access: 'matches' },
  { key: 'company', hash: 'company', label: 'Company', access: 'manager' },
];

export default function ManageNav({
  currentPath,
  canManagePersons = false,
  canManageTeams = false,
  canManageMatches = false,
  canManageCompany = false,
  // Optional counts shown inline next to each tab label.
  // { persons: 1284, teams: 92, unlinked: 47, training: 23 }
  counts = {},
}) {
  const visibleItems = NAV_ITEMS.filter((item) => {
    if (item.access === 'all') return true;
    if (item.access === 'persons') return canManagePersons;
    if (item.access === 'teams') return canManageTeams;
    if (item.access === 'matches') return canManageMatches;
    if (item.access === 'manager') return canManageCompany;
    return false;
  });

  // Determine active item from currentPath (e.g., /manage/teams or /manage/company/users)
  const getActiveKey = () => {
    if (currentPath === '/manage') return 'dashboard';
    if (currentPath.startsWith('/manage/company')) return 'company';
    if (currentPath.startsWith('/manage/training')) return 'training';
    if (currentPath.startsWith('/manage/teams')) return 'teams';
    if (currentPath.startsWith('/manage/persons')) return 'persons';
    if (currentPath.startsWith('/manage/unlinked')) return 'unlinked';
    if (currentPath.startsWith('/manage/competitions')) return 'competitions';
    return 'dashboard';
  };

  const activeKey = getActiveKey();

  const handleNavigate = (key) => {
    const item = visibleItems.find((i) => i.key === key);
    if (!item) return;
    if (item.hash) {
      window.location.hash = item.hash;
    } else {
      // Clear hash for dashboard
      window.history.pushState({}, '', '/manage');
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  const tabs = visibleItems.map((item) => ({
    id: item.key,
    label: item.label,
    count: counts[item.key],
  }));

  return (
    <TabBar
      tabs={tabs}
      active={activeKey}
      onChange={handleNavigate}
      variant="bar"
    />
  );
}
